export const HEADERS = {
  transaccional: {
    title: 'Cuenta Transaccional',
    description:
      'Abre tu Cuenta Transaccional en pocos minutos, sin ir a una agencia, sin papeles.  Sin depósito inicial y sin costo de mantenimiento.',
    keywords:
      'cuenta, ahorro, programado, simple, corriente, tarjeta, debito, banco, pichincha, internexo, Ecuador, Quito, Guayaquil, banca, personas, online, digital, tiempo, virtual, app, movil, minutos, Pacífico, electrónica, bancaria, apertura, canales, delivery, agencia, cédula, ecuatoriana, pagos, Netflix, Spotify, Uber, Cabify',
    image: 'https://micuenta.pichincha.com/assets/img/banner-og.jpg',
  },
  flexible: {
    title: 'Cuenta de Ahorro Flexible hace crecer tu dinero hasta 5%',
    description:
      'Abre la Cuenta de Ahorro Flexible de Banco Pichincha y empieza a hacer realidad tus sueños. Harás crecer tu dinero con una tasa de 5% y lo tendrás disponible cuando lo necesites.',
    keywords:
      'cuenta, ahorro, programado, simple, corriente, tarjeta, debito, banco, pichincha, internexo, Ecuador, Quito, Guayaquil, banca, personas, online, digital, tiempo, virtual, app, movil, minutos, Pacífico, electrónica, bancaria, apertura, canales, delivery, agencia, cédula, ecuatoriana, pagos, Netflix, Spotify, Uber, Cabify',
    image: 'https://micuenta.pichincha.com/assets/img/logo-og.png',
  },
  migrante: {
    title: 'Cuenta Transaccional',
    description:
      'Envía tu dinero desde fuera del país de forma sencilla y recíbelo inmediatamente en Ecuador.',
    keywords:
      'cuenta, ahorro, programado, simple, corriente, tarjeta, debito, banco, pichincha, internexo, Ecuador, Quito, Guayaquil, eeuu, Estados Unidos, us, banca, personas, online, digital, tiempo, virtual, app, movil, minutos, Pacífico, electrónica, bancaria, apertura, canales, delivery, migrante, cédula, ecuatoriana, pagos, Netflix, Spotify, Uber, Cabify',
    image: 'https://micuenta.pichincha.com/assets/img/banner-og.jpg',
  },
}
